module.exports = __webpack_public_path__ + "static/media/document-thumbnail-CBRimg5.a248ddb5.png";